import {Validator} from "vee-validate";

export function registerValidators() {
  Validator.extend("greater_than_0", {
    validate: (value: any) => {
      return value > 0;
    },
  });

  Validator.extend(
    "greater_than_equal_to",
    {
      validate: (value: any, { min }: { min: any }) => {
        return value >= Number(min);
      }
    },
    { paramNames: ["min"] }
  );
}

